import React, { ChangeEvent, useState } from "react";
import AddSvg from "../../assets/taiga-uikit/icons/add.svg?react";
import MinusSvg from "../../assets/taiga-uikit/icons/minus.svg?react";
import { _colorText, _size, _sizeText, _style } from "../../core/core";
import { Button } from "../button/button";
import { Text } from "../texts/text";
import "./Input.css";

interface InputCounterProps {
  size?: _size;
  filled?: boolean;
  labelOutside?: string;
  label?: string;
  placeholder?: string;
  description?: string;
  descriptionComp?: React.ReactNode;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  value: number | string;
  setValue: React.Dispatch<React.SetStateAction<number>>;
  focusStart?: boolean;
  validation?: () => string;
  onChange?: (value: number | string) => void;
  onBlurHandel?: () => void;
}

export const InputCounter: React.FC<InputCounterProps> = ({
  size = _size.M,
  filled = false,
  labelOutside,
  label,
  placeholder,
  description,
  descriptionComp,
  onKeyDown,
  value,
  setValue,
  validation,
  onChange: onChangeEvent,
  onBlurHandel,
}) => {
  const variantsClassName = (): string => {
    return validation && messageError !== ""
      ? `input-field input-field-${size} input-field-counter error input-filled-${filled}`
      : `input-field input-field-${size} input-field-counter input-filled-${filled}`;
  };

  const [messageError, setMessageError] = useState<string>("");

  const handlePlus = (): void => {
    const newValue = Number(value) + 1;
    setValue(newValue);
    onChangeEvent?.(newValue);
    onBlurHandel?.();
  };

  const handleMinus = (): void => {
    if (Number(value) > 1) {
      const newValue = Number(value) - 1;
      setValue(newValue);
      onChangeEvent?.(newValue);
    }
    onBlurHandel?.();
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    if (validation) {
      setMessageError(validation());
    }

    const newValue = event.target.value;
    if (newValue === "" || Number(newValue) <= 0) {
      return;
    }

    setValue(Number(newValue));
    onChangeEvent?.(newValue);
  };

  return (
    <div className={`field field-counter input-filled-${filled}`}>
      {labelOutside && (
        <Text size={_sizeText.xs} color={_colorText.neutral}>
          {labelOutside}
        </Text>
      )}
      <div className={variantsClassName()}>
        <div className={`field-content-counter input-filled-${filled}`}>
          <Button
            style={_style.clear}
            onClick={handleMinus}
            icon_left={<MinusSvg />}
          />
          <input
            type="number"
            value={value}
            placeholder={placeholder || label || ""}
            onBlur={onBlurHandel}
            onChange={handleChange}
            onKeyDown={onKeyDown}
          />
          <Button
            style={_style.clear}
            onClick={handlePlus}
            icon_right={<AddSvg />}
          />
        </div>
      </div>
      {descriptionComp ? (
        <>{descriptionComp}</>
      ) : (
        description && (
          <Text size={_sizeText.xs} color={_colorText.neutral}>
            {description}
          </Text>
        )
      )}
      {messageError && (
        <Text size={_sizeText.xs} color={_colorText.negative}>
          {messageError}
        </Text>
      )}
    </div>
  );
};
